import jwtDecode from 'jwt-decode'
import _ from 'lodash'

export const Scopes = {
    ACCESS_PANEL: 'ACCESS_PANEL',
    APPLICATION_LIST: 'APPLICATION_LIST',
    APPLICATION_STATS: 'APPLICATION_STATS',
    REVIEW_LIST: 'REVIEW_LIST',
    OPTIONS_MANAGEMENT: 'OPTIONS_MANAGEMENT',
    OPTIONS_LIST_CNAES: 'OPTIONS_LIST_CNAES',
    OPTIONS_LIST_SENIORITIES: 'OPTIONS_LIST_SENIORITIES',
    OPTIONS_LIST_SPECIALTIES: 'OPTIONS_LIST_SPECIALTIES',
    OPTIONS_LIST_COMPLIANCE_LIST: 'OPTIONS_LIST_COMPLIANCE_LIST',
    OPTIONS_LIST_COWORKERS: 'OPTIONS_LIST_COWORKERS',
    USER_MANAGEMENT: 'USER_MANAGEMENT',
    USER_MANAGEMENT_LIST_USERS: 'USER_MANAGEMENT_LIST_USERS',
    USER_MANAGEMENT_EDIT_USER: 'USER_MANAGEMENT_EDIT_USER',
    USER_ACTIVITY_LIST_LOGS: 'USER_ACTIVITY_LIST_LOGS',
    GET_SCOPES: 'GET_SCOPES',
    PASSWORD_CHANGE: 'PASSWORD_CHANGE',
}

export const readOptionsManagementScopes = [
    Scopes.OPTIONS_LIST_CNAES,
    Scopes.OPTIONS_LIST_SENIORITIES,
    Scopes.OPTIONS_LIST_SPECIALTIES,
    Scopes.OPTIONS_LIST_COMPLIANCE_LIST,
    Scopes.OPTIONS_LIST_COWORKERS,
]

export const AuthStates = {
    AUTHORIZED: 'AUTHORIZED', // The user is authorized with the required scope and the token is not expired.
    EXPIRED: 'EXPIRED',      // The user's token has expired, regardless of the scope.
    FORBIDDEN: 'FORBIDDEN',  // The user is not authorized with the required scope.
}

export const getUserTokenStateFromDecoded = (decodedToken, requiredScopes) => {
    const tokenScopes = decodedToken.scopes || []
    const isAuthorized = requiredScopes.every(scope => tokenScopes.includes(scope))
    const isExpired = decodedToken.exp <= Date.now() / 1000 

    // The token has the required scope and is not expired.
    if (isAuthorized && !isExpired) {
        return AuthStates.AUTHORIZED
    }

    // The token is not expired, but does not have the required scope.
    if (!isAuthorized) {
        return AuthStates.FORBIDDEN
    }

    // The token has the required scope, but it is expired.
    return AuthStates.EXPIRED
}

export const decodeToken = (token) => {
    if (_.isEmpty(token)) {
        return null
    }

    try {
        return jwtDecode(token)
    } catch (error) {
        console.error('Failed to decode token:', error)
        return null
    }
}


/**
 * Get the user's token state based on authorization and expiration.
 * @param {string} token - The user's token.
 * @param {[string]} requiredScopes - The required scope.
 * @returns {string} - The user's token state.
 */
export const getUserTokenState = (token, requiredScopes) => {
    // If no token is provided, the user is not authorized.
    if (_.isEmpty(token)) {
        return AuthStates.FORBIDDEN
    }

    return getUserTokenStateFromDecoded(decodeToken(token), requiredScopes)
}

